import React from 'react';

const user = (props) => {
    return <h1>Username: {props.name}</h1>
}

export default user;